import React, { createContext, useContext } from 'react';

type ClaimShopSettings = {
  isClaimMeCustomer: boolean;
  isEasyDOREnabled: boolean;
  isInvoiceExtractionEnabled: boolean;
  isInvoiceImportEnabled: boolean;
  isDORSigningLinkEnabled: boolean;
};

const defaultValue: ClaimShopSettings = {
  isClaimMeCustomer: false,
  isEasyDOREnabled: false,
  isInvoiceExtractionEnabled: false,
  isInvoiceImportEnabled: false,
  isDORSigningLinkEnabled: false,
};

const ClaimsShopSettingsContext = createContext<ClaimShopSettings>(defaultValue);

type Props = {
  value?: Partial<ClaimShopSettings>;
  children: React.ReactNode;
};

export function ClaimsShopSettingsContextProvider({ value, children }: Props) {
  return (
    <ClaimsShopSettingsContext.Provider value={{ ...defaultValue, ...value }}>
      {children}
    </ClaimsShopSettingsContext.Provider>
  );
}

export function useClaimsShopSettings(): ClaimShopSettings {
  return useContext(ClaimsShopSettingsContext);
}
